import store from '../../admin/store'
import { normalize } from 'normalizr'
import schema from './schema'
import {
    FRIENDSHIP_STATE_ACCEPTED,
    MESSENGER_VISIBILITY_ALL,
} from '../../consts'

import {
    EVENT_NAVIGATION,
    TYPE_MESSENGER_THREAD,
    sendWebViewEvent,
} from '../../events-webview'

/**
 * Mark active thread as read
 *
 * @returns {Promise}
 */
export const markThreadAsRead = (messenger, activeThread) => window.axios
    .patch(`${window.APP_CONFIG.REACT_APP_API_URL}api/messenger/${activeThread}/mark-as-read`)
    .then(({ data }) => {
        store.dispatch({
            type: 'MESSENGER_SET_UNREAD_MESSAGES_COUNT',
            count: data,
        })
        store.dispatch({
            type: 'MESSENGER_SET_THREADS',
            threads: {
                ...messenger.threads,
                [activeThread]: {
                    ...messenger.threads[activeThread],
                    unread_messages: 0,
                },
            },
        })
    })

/**
 * Can show messenger button based on authed user id, friendship state and messenger visibility of the other user
 *
 * @param {Object} authedUser
 * @param {Object} userToMessage object that needs to have a sportnectionStatus property
 * @returns {boolean}
 */
export const canShowMessengerButton = (authedUser, userToMessage) => (userToMessage?.sportnectionStatus?.data?.friendship_state === FRIENDSHIP_STATE_ACCEPTED || userToMessage?.messengerAllowed?.data?.id === MESSENGER_VISIBILITY_ALL) && userToMessage?.id !== authedUser?.id

/**
 * Redirects to conversation
 *
 * @param {Object} sportnection target user sportnect profile
 * @param {Object} history history component to call for url redirection
 * @param {Object} params optional thread redirection parameters
 *
 * @returns {Promise}
 */
export const redirectToConversation = (sportnection, history, params = null) => {
    let postData = {
        recipient: sportnection.slug || sportnection.id,
    }

    if (params) {
        postData = {
            ...postData,
            ...params,
        }
    }

    return window.axios.post(`${window.APP_CONFIG.REACT_APP_API_URL}api/messenger?include=participants`, postData).then(({ data }) => {
        const result = data.data

        const {
            entities: {
                participants,
                users,
                threads,
            },
        } = normalize([result], [schema])

        const messengerState = store.getState().messenger

        store.dispatch({
            type: 'MESSENGER_SET_PARTICIPANTS',
            participants: {
                ...messengerState.participants,
                ...participants,
            },
        })
        store.dispatch({
            type: 'MESSENGER_SET_USERS',
            users: {
                ...messengerState.users,
                ...users,
            },
        })
        store.dispatch({
            type: 'MESSENGER_SET_THREADS',
            threads: {
                ...threads,
                ...messengerState.threads,
            },
        })

        const webViewData = {
            close: true,
            data: {
                ...TYPE_MESSENGER_THREAD,
                slug: result.slug,
                name: result.thread_name,
            },
        }

        if (sendWebViewEvent(EVENT_NAVIGATION, webViewData) === false) {
            history.push(`/chat/t/${result.slug}`)
        }
    })
}

/**
 * Sort threads of messenger by latest message
 *
 * @param {Object} threads
 * @returns {any[]}
 */
export const sortThreads = threads => {
    if (!threads) {
        return {}
    }

    const sortedThreads = Object.values(threads).sort((firstThread, secondThread) => {
        const firstThreadCreatedMessage = firstThread?.lastMessage?.data?.created_at
        const secondThreadCreatedMessage = secondThread?.lastMessage?.data?.created_at
        const firstThreadDate = firstThreadCreatedMessage ? new Date(firstThreadCreatedMessage) : 0
        const secondThreadDate = secondThreadCreatedMessage ? new Date(secondThreadCreatedMessage) : 0

        return secondThreadDate - firstThreadDate
    })

    let result = {}

    sortedThreads.forEach(thread => {
        result[thread.slug] = thread
    })

    return result
}

